<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Letter Upload
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 10px;" [ngClass]="{'colHide': !this.common.PageRight.IsAdd}">Upload</th>
                        <th style="width: 10px;">Download</th>
                        <th style="width: 50px;">Code</th>
                        <th>Name</th>
                        <th style="width: 200px;">Document</th>
                        <th style="width: 20px;">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="text-align: -webkit-center; width: 10px;"
                            [ngClass]="{'colHide': !this.common.PageRight.IsAdd}">
                            <Input id="uploadfile{{i}}" (change)="upload($event,TableData['LetterCode'],i)"
                                name="uploadfile{{i}}" accept=".doc,.docx" type="file" #uploadfile required
                                matTooltip="Choose File" matTooltipClass="tooltip" style="display: none;" />

                            <div style="width: 10px;" (click)="uploadfile.click()"><span target="_blank"
                                    class="bi bi-upload text-primary" style="-webkit-text-stroke: 1px"></span></div>
                        </td>
                        <td style="text-align: -webkit-center;width: 10px;">
                            <div style="width: 10px;"><a
                                    *ngIf="TableData['LetterFileName'] != '' && TableData['LetterFileName'] != null"
                                    [href]="GetLink(i)" target="_blank" class="bi bi-file-earmark-check  text-primary"
                                    style="-webkit-text-stroke: 1px"></a>
                            </div>
                        </td>
                        <td style="width: 50px;">{{TableData['LetterCode']}}</td>
                        <td>{{TableData['LetterName']}}</td>
                        <td style="width: 200px;">{{TableData['LetterDocumentTypeCode']}} -
                            {{TableData['LetterDocumentTypeName']}}</td>
                        <td style="width: 20px;"><span class="badge"
                                [ngClass]="{'success': TableData['Active'],'danger': !TableData['Active'],}">
                                {{TableData['Active']?'Active':'Deactive'}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>